var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProControlFlame = function SvgProControlFlame(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    width: 26.072,
    height: 39.02,
    viewBox: "0 0 26.072 39.02",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-no-active",
    fill: "#b6b6b6",
    d: "M13.8 38.868s-4.663-.819-6.188-1.874C4.936 35.14 4.666 32.87 4.666 32.87c-1.683-8.25-.9-7.918.544-20.81-.733 1.197 5.988 3.001 7.317 10.822 2.015 12.406 4.984 13.414 1.803 15.985"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-one-no-active",
    fill: "#7b7a7a",
    d: "M7.457 19.674c-.154-2.722 1.788-3.436 2.815-7.86.55-2.368.83-6.017-.013-11.187 0 0 6.03 4.57 7.573 8.577 1.187 3.083 2.986 7.735 5.637 14.546 4.302 15.368-9.746 14.665-9.685 14.824s-5.745-.08-4.393-5.487c1.352-5.408-1.323-8.416-1.934-13.414z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-two-no-active",
    fill: "#aaa",
    d: "M20.712 10.002s-1.199 6.404-3.658 9.449c-2.347 4.493-7.642 11.167-1.512 18.007 0 0 15.703-5.009 5.17-27.456z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-three-no-active",
    fill: "#bababa",
    d: "M14.102 8.738c1.468 3.08-1.978 20.705-.61 30.51 0 0 11.615-6.94 7.874-15.74-1.684-9.106-5.963-13.25-7.264-14.77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-six-no-active",
    fill: "#a5a5a5",
    d: "M10.862 13.644c-3.547 2.312-7.635 22.528 1.049 24.9 7.563 3.063-1.864-15.769-1.049-24.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-four-no-active",
    fill: "#747474",
    d: "M22.215 16.607s.106 8.533-2.847 13.304c-2.951 4.772-2.836 8.885-2.836 8.885s6.889-1.154 7.73-8.748c.35-3.172.679-8.322-2.047-13.442z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-five-no-active",
    fill: "#767676",
    d: "M5.56 15.411S.793 34.539 8.543 37.52 7.629 23.284 5.56 15.411"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProControlFlame);
export default ForwardRef;